import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { useAuth } from './context/AuthContext';
import Swal from "sweetalert2";

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false); // Track loading state
    const navigate = useNavigate();
    const { handleLogin } = useAuth();
    const [showPassword, setShowPassword] = useState(false);
    const [is2FARequired, setIs2FARequired] = useState(false); // Track if 2FA is required
    const [twoFactorCode, setTwoFactorCode] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [timer, setTimer] = useState(60); // countdown seconds
    const [canResend, setCanResend] = useState(false);
    const timerRef = useRef(null);

    function getDefaultDashboardByPermission(permissions = []) {
        if (permissions.includes("dashboard-main")) return "/dashboard";
        if (permissions.includes("dashboard-sales")) return "/sales-dashboard";
        if (permissions.includes("dashboard-account")) return "/account-dashboard";
        if (permissions.includes("dashboard-operation")) return "/operation-dashboard"; // optional
        return '/home';
    }
    // useEffect(() => {
    //     if (localStorage.getItem('user-info')) {
    //         navigate('/');
    //     }
    // }, [navigate]);


    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user-info'));
        if (user) {
            const defaultRoute = getDefaultDashboardByPermission(user.permissions || []);
                navigate(defaultRoute);
            // } else {
            //     Swal.fire({
            //         icon: 'error',
            //         title: 'Access Denied',
            //         text: 'You do not have permission to access any dashboard.',
            //     });
            // }
        }
    }, [navigate]);
//     useEffect(() => {
//     const user = JSON.parse(localStorage.getItem('user-info'));
//     if (user && window.location.pathname === "/") {
//         const defaultRoute = getDefaultDashboardByPermission(user.permissions || []);
//         if (defaultRoute) {
//             navigate(defaultRoute, { replace: true });
//         }
//     }
// }, [navigate]);



    async function login() {
        setLoading(true); // Set loading state to true when login starts
        const item = { email, password };
        const backendUrl = process.env.REACT_APP_BACKEND_URL;

        try {
            const response = await axios.post(
                `${backendUrl}/api/login`,
                item,
                {
                    withCredentials: true,
                    headers: {
                        'Tenant-Origin': window.location.origin,
                    }
                }
            );

            const result = response.data;

            // if (result.message) {

            //     setErrorMessage(result.message); // Show 2FA prompt message

            //     navigate('/verification', { state: { email, password } });
            if (result.require_2fa) {
                setErrorMessage(result.message); // Optional: show message in UI
                navigate('/verification', { state: { email, password } });
                return; // stop further execution
            
            

            } else {
                localStorage.setItem('user-info', JSON.stringify(result));
                const origin = window.location.origin;
                localStorage.setItem('user-origin', origin);
                handleLogin(result);
                // navigate('/');
                const permissions = result.permissions || [];
                const defaultRoute = getDefaultDashboardByPermission(permissions);

                // if (defaultRoute) {
                    navigate(defaultRoute);
                // } else {
                //      Swal.fire({
                //     toast: true,
                //     position: 'top-end',
                //     icon: 'error',
                //     title: 'You do not have permission to access any dashboard.',
                //     timer: 3000,
                //     timerProgressBar: false,
                //     showConfirmButton: false,
                //     didOpen: () => {
                //         const container = Swal.getContainer();
                //         container.style.top = '50px';
                //     },
                // });
                // }
            }
        } catch (error) {

            if (error.response?.data?.error === 'User has no assigned role') {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'User has no assigned role',
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
            } else if (error.response?.data?.message) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: error.response.data.message,
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
            } else if (error.response?.data?.error) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: error.response.data.error,
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
            } else {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'An error occurred. Please try again.',
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
            }
        } finally {
            setLoading(false); // Set loading state to false once the response is received
        }
    }
    

    return (
        <div className="account-pages my-5 pt-sm-5">
            <Container>
                <Row className="justify-content-center">
                    <Col md={8} lg={6} xl={5}>
                        <Card className="overflow-hidden shadow-lg border-0">
                            <div className="bg-primary bg-soft">
                                <div className="row">
                                    <div className="col-7">
                                        <div className="text-primary p-4">
                                            <h5 className="text-primary">Welcome Back!</h5>
                                        </div>
                                    </div>
                                    <div className="col-5 align-self-end">
                                        <img src="assets/images/profile-img.png" alt="" className="img-fluid" />
                                    </div>
                                </div>
                            </div>
                            <Card.Body className="pt-0">
                                <div className="auth-logo text-center mb-4">
                                    <div className="avatar-md profile-user-wid mb-4">
                                        <span className="avatar-title rounded-circle bg-light">
                                            <img src="assets/images/logo-light.svg" alt="" className="rounded-circle" height="34" />
                                        </span>
                                    </div>
                                </div>
                                <div className="p-2">
                                    <form className="form-horizontal">
                                        {/* Username / Email Input */}
                                        <div className="mb-3">
                                            <label htmlFor="username" className="form-label form-font" >Username</label>
                                            <input
                                                type="text"
                                                className="form-control input-border input-feild"
                                                id="username"
                                                placeholder="Enter username"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </div>


                                        <div className="mb-3">
                                            <label className="form-label form-font">Password</label>
                                            <div className="input-group auth-pass-inputgroup">
                                                <input
                                                    type={showPassword ? "text" : "password"} // Dynamically set input type
                                                    className="form-control input-border input-feild"
                                                    placeholder="Enter password"
                                                    aria-label="Password"
                                                    aria-describedby="password-addon"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                                <button
                                                    className="btn btn-light"
                                                    type="button"
                                                    id="password-addon"
                                                    onClick={() => setShowPassword(!showPassword)} // Toggle password visibility
                                                >
                                                    <i className={`mdi ${showPassword ? "mdi-eye-off-outline" : "mdi-eye-outline"}`}></i>
                                                </button>
                                            </div>
                                        </div><br />

                                        <div className="mt-3 d-grid">
                                            <button
                                                className="btn btn-primary waves-effect waves-light"
                                                type="button"
                                                onClick={login}
                                                disabled={loading}
                                            >

                                                {loading && (
                                                    <>
                                                        <Spinner
                                                            animation="border"
                                                            size="sm"
                                                            style={{ marginRight: '10px' }}
                                                        />
                                                    </>
                                                )}
                                                Log In
                                            </button>
                                        </div>

                                        <div className="mt-4 text-center">
                                            <Link to="/forgot-password" title="Forgot password?" className="text-muted font-size-12 fst-italic">
                                                Forgot <span className="text-primary fw-medium">Password</span>?
                                            </Link>
                                        </div>

                                    </form>

                                    {/* {errorMessage && <p className="text-danger">{errorMessage}</p>} */}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Login;

